import React from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import classes from './style.module.scss';

export interface LineTypeIconProps {
    type: IssueOrServiceType;
    issueId: number;
}

export type LineTypeIconComponent = React.FC<LineTypeIconProps>;

const LineTypeIcon: LineTypeIconComponent = ({ type, issueId }) => {
    if (issueId == null || issueId === 0) {
        return null;
    }

    const isIssue = type === IssueOrServiceType.ISSUE;

    return (
        <div
            className={classNames(
                classes['type-icon-wrap'],
                isIssue ? classes.issue : classes.service,
            )}
        >
            <Icon name={isIssue ? 'warning' : 'build'} />
        </div>
    );
};

export default LineTypeIcon;
